import {
  User,
  Lock,
  Mail,
  Eye,
  EyeOff,
  Check,
  X,
  AlertCircle,
  Info,
  CheckCircle,
  XCircle,
  Calendar,
  FileText,
  Download,
  RefreshCw,
  LogOut,
  Home,
  CreditCard,
  CircleHelp as Help,
  History,
  Settings,
  Phone,
  Menu,
  ChevronDown,
  ChevronRight,
  Search,
  Filter,
  Plus,
  Minus,
  ArrowLeft,
  ArrowRight,
  Loader2,
  HandCoins,
  Receipt
} from 'lucide-react';
import { cn } from '../../utils/cn';

const legacyFiles = [
  'usuario.png',
  'usuario2.png',
  'contrasena2.png',
  'digitecod.png',
  'icono_pdf.png',
  'boton_pdf.jpg',
  'boton_pdf1.jpg',
  'excel.png',
  'descargar.png',
  'calendar.png',
  'boton_actualizar.png',
  'boton_actualizar1.png',
  'boton_salir.png',
  'regresar.png',
  'cuadro_atencion.png',
  'ayuda_desplegado.png',
  'ayuda_en_linea.jpg',
  'instructivo.png',
  'instructivo2.png',
  'instructivoant.png',
  'instructivo2ant.png',
  'IconWhp.png',
  'link-icon.png',
  'icono.png',
];

const Icon = ({
  name,
  legacyIcon,
  size = 'md',
  variant = 'default',
  className,
  ...props
}) => {
  const sizes = {
    xs: 'h-3 w-3',
    sm: 'h-4 w-4',
    md: 'h-5 w-5',
    lg: 'h-6 w-6',
    xl: 'h-8 w-8',
    '2xl': 'h-10 w-10',
  };

  const variants = {
    default: 'text-gray-600',
    primary: 'text-ec-primary-600',
    secondary: 'text-ec-secondary-500',
    success: 'text-success-500',
    danger: 'text-danger-500',
    warning: 'text-warning-500',
    info: 'text-info-500',
    muted: 'text-ec-gray-500',
    white: 'text-white',
  };

  if (legacyIcon && legacyFiles.includes(legacyIcon)) {
    return (
      <img
        src={`/images/${legacyIcon}`}
        alt={legacyIcon}
        className={cn(sizes[size], className)}
        {...props}
      />
    );
  }

  const iconMap = {
    user: User,
    lock: Lock,
    mail: Mail,
    eye: Eye,
    'eye-off': EyeOff,
    check: Check,
    x: X,
    'alert-circle': AlertCircle,
    info: Info,
    'check-circle': CheckCircle,
    'x-circle': XCircle,
    calendar: Calendar,
    'file-text': FileText,
    download: Download,
    'refresh-cw': RefreshCw,
    'log-out': LogOut,
    home: Home,
    'credit-card': CreditCard,
    history: History,
    settings: Settings,
    help: Help,
    phone: Phone,
    menu: Menu,
    'chevron-down': ChevronDown,
    'chevron-right': ChevronRight,
    search: Search,
    filter: Filter,
    plus: Plus,
    minus: Minus,
    'arrow-left': ArrowLeft,
    'arrow-right': ArrowRight,
    loading: Loader2,
    'hand-coins': HandCoins,
    receipt: Receipt
  };

  const LucideIcon = name ? iconMap[name] || Info : Info;

  return (
    <LucideIcon
      className={cn(
        sizes[size],
        variants[variant],
        'transition-colors duration-200',
        className
      )}
      {...props}
    />
  );
};

Icon.User = (props) => <Icon name="user" {...props} />;
Icon.Lock = (props) => <Icon name="lock" {...props} />;
Icon.Mail = (props) => <Icon name="mail" {...props} />;
Icon.Calendar = (props) => <Icon name="calendar" {...props} />;
Icon.PDF = (props) => <Icon name="file-text" {...props} />;
Icon.Download = (props) => <Icon name="download" {...props} />;
Icon.Refresh = (props) => <Icon name="refresh-cw" {...props} />;
Icon.Logout = (props) => <Icon name="log-out" {...props} />;
Icon.Loading = (props) => (
  <Icon name="loading" className="animate-spin" {...props} />
);

export default Icon;
